<script>
import baseMixin from '@/mixins/baseMixin'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ResetPasswordDialogAndButton',
  mixins: [baseMixin],
  props: {
    candidateId: {
      type: Number,
      required: true,
    },
    candidateName: {
      type: String,
      required: true,
    },
  },
  data: () => {
    return {
      dialog: false,
    }
  },
  computed: {
    ...mapGetters({
      isLoadingCandidateUserDetailsCRUD:
        'candidate/isLoadingCandidateUserDetailsCRUD',
    }),
  },
  methods: {
    ...mapActions({ resetPassword: 'candidate/resetPassword' }),
    async handleResetPassword() {
      const response = await this.resetPassword(this.candidateId)

      if (!response.isSuccess) return

      this.dialog = false
    },
  },
}
</script>

<template>
  <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        id="reset-password-button"
        color="primary"
        text
        v-bind="attrs"
        v-on="on"
        >{{ $t('candidate.resetPasswordBtnLabel') }}</v-btn
      >
    </template>
    <v-card id="reset-password-dialog-card" tile class="overflow-x-hidden">
      <h6 class="text-h6">{{ $t('candidate.resetPasswordDialogTitle') }}</h6>
      <p class="text-body-2">{{
        $t('candidate.resetPasswordDialogPrompt', { candidateName })
      }}</p>
      <v-card-actions class="justify-end pa-0">
        <v-btn
          color="primary"
          text
          :disabled="isLoadingCandidateUserDetailsCRUD"
          @click="dialog = false"
        >
          {{ $t('general.cancel') }}
        </v-btn>
        <v-btn
          id="confirm-reset-email-button"
          color="primary"
          :loading="isLoadingCandidateUserDetailsCRUD"
          @click="handleResetPassword"
        >
          {{ $t('general.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
